import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {MatDialogRef} from '@angular/material/dialog';
import {FactorDetailOptions} from './options/factor-detail.options';
import {FactorStatusHelper} from '../../../../enums/factor.status';
import {OrderStatusHelper} from '../../../../enums/order.status';
import {ListResponse} from '../../../../network/service/list.response';
import {SnackBarUtil} from '../../../../util/snack.bar.util';
import {RequestType} from '../../../../enums/request.type';

@Component({
  selector: 'app-factor-detail',
  standalone: false,
  templateUrl: './factor-detail.component.html',
  styleUrls: ['./factor-detail.component.scss']
})
export class FactorDetailComponent extends BaseComponent implements OnInit {
  factorDetailOptions = new FactorDetailOptions();
  factor: any;

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<FactorDetailComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getFactors(this.tableProperties.offset, this.tableProperties.limit, 'User,FactorOrders,FactorOrders.Order,FactorOrders.Order.ServicePrice,FactorOrders.Order.ServicePrice.Service,FactorOrders.Order.ServicePrice.Service.Category,PaymentMethod', RequestType.ONE, {
      Filter: {
        Values: [{
          Field: 'FactorId',
          Type: 'EQ',
          Value: this.factorDetailOptions.factorId
        }]
      },
      Order: {}
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.factor = res.data;
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  getUserDisplayName(user: any): string {
    if (!user) return '';
    const fullName = `${user.FirstName || ''} ${user.LastName || ''}`.trim();
    const mobileNumber = user.MobileNumber || '';
    if (fullName && mobileNumber) {
      return `${fullName} (${mobileNumber})`;
    } else if (fullName) {
      return fullName;
    } else if (mobileNumber) {
      return mobileNumber;
    }
    return '';
  }

  getFactorStatusText(status: string): string {
    const statusKey = FactorStatusHelper.getStatusText(status);
    return this.translateService.instant(statusKey);
  }

  getFactorStatusColor(status: string): string {
    return FactorStatusHelper.getStatusColor(status);
  }

  getFactorStatusIcon(status: string): string {
    return FactorStatusHelper.getStatusIcon(status);
  }

  getOrderStatusText(status: string): string {
    const statusKey = OrderStatusHelper.getStatusText(status);
    return this.translateService.instant(statusKey);
  }

  getOrderStatusColor(status: string): string {
    return OrderStatusHelper.getStatusColor(status);
  }

  getPaymentStatus(): string {
    if (this.factor?.BankStatusCode === 0) {
      return 'Paid';
    } else {
      return 'NotPaid';
    }
  }

  getPaymentStatusColor(): string {
    if (this.factor?.BankStatusCode === 0) {
      return '#4caf50';
    } else {
      return '#f44336';
    }
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('fa-IR').format(amount) + ' تومان';
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('fa-IR');
  }

  getOrderCount(): number {
    return this.factor?.FactorOrders?.length || 0;
  }

  getTotalItems(): number {
    let total = 0;
    if (this.factor?.FactorOrders) {
      this.factor.FactorOrders.forEach((factorOrder: any) => {
        if (factorOrder?.Order) {
          total += factorOrder.Order.Count || 0;
        }
      });
    }
    return total;
  }

  closeDialog() {
    this.matDialogRef.close();
  }
}
